import { render, staticRenderFns } from "./indexPC.vue?vue&type=template&id=21da7fa9&scoped=true&"
import script from "./indexPC.vue?vue&type=script&lang=js&"
export * from "./indexPC.vue?vue&type=script&lang=js&"
import style0 from "./indexPC.vue?vue&type=style&index=0&id=21da7fa9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da7fa9",
  null
  
)

export default component.exports